import { render } from "./DriverPortal.vue?vue&type=template&id=1f67ad0f&scoped=true"
import script from "./DriverPortal.vue?vue&type=script&lang=js"
export * from "./DriverPortal.vue?vue&type=script&lang=js"

import "./DriverPortal.vue?vue&type=style&index=0&id=1f67ad0f&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f67ad0f"]])

export default __exports__